import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, ChannelFullDTO } from '../../../services/api/api';
import { ErrorService } from '../../../services/error.service';
import { UtilService } from '../../../services/util.service';
import { PermissionService } from '../../../services/permission.service';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-channel-details',
  templateUrl: './channel-details.component.html',
  styleUrls: ['./channel-details.component.scss'],
  standalone: false,
})
export class ChannelDetailsComponent implements OnInit {
  channelId: number;
  channel: ChannelFullDTO;

  constructor(
    private activatedRoute: ActivatedRoute,
    private api: API,
    private errorHandler: ErrorService,
    public util: UtilService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.channelId = +params.channelID;
      this.api
        .ss_nm_Channel_retrieveById(this.channelId)
        .pipe(take(1), takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (e: ChannelFullDTO) => {
            this.channel = e;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    });
  }
}
